export default __webpack_public_path__ + "0298a9a20b1002577cda38e08a2885ba.png";